import { render, staticRenderFns } from "./Pledge.vue?vue&type=template&id=6963b32e&scoped=true&"
import script from "./Pledge.vue?vue&type=script&lang=js&"
export * from "./Pledge.vue?vue&type=script&lang=js&"
import style0 from "./Pledge.vue?vue&type=style&index=0&id=6963b32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963b32e",
  null
  
)

export default component.exports